import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { MembersQuestionIcon } from '@onesource/icons';
import { useNavigate } from '@tanstack/react-router';
import { MouseEvent, useCallback, useState } from 'react';

export function ContactPopover() {
  const navigate = useNavigate();
  const theme = useTheme();

  const [anchorElHelpCenter, setAnchorElHelpCenter] = useState<null | HTMLElement>(null);

  const handleOpenHelpCenterMenu = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorElHelpCenter(event.currentTarget);
  }, []);

  const handleCloseHelpCenterMenu = useCallback(() => {
    setAnchorElHelpCenter(null);
  }, []);

  const handleContactSupport = useCallback(() => {
    handleCloseHelpCenterMenu();
    navigate({ to: '/contact' });
  }, [handleCloseHelpCenterMenu, navigate]);

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Tooltip title="Support">
        <IconButton disableRipple onClick={handleOpenHelpCenterMenu} sx={{ p: { xs: 0.5, md: 0.6 } }}>
          <MembersQuestionIcon color={theme.palette.primary.main} />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '20px' }}
        id="help-center-menu"
        anchorEl={anchorElHelpCenter}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElHelpCenter)}
        onClose={handleCloseHelpCenterMenu}
      >
        <MenuItem onClick={handleContactSupport}>
          <Typography
            textAlign="center"
            variant="body2"
            sx={{ fontWeight: 600, color: theme => theme.palette.grey[800] }}
          >
            Contact Support
          </Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
}
